












































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({
	name: 'StaffPaymentsSearch',
})
export default class Search extends Vue {
	@Prop() private paginateKey: string;
	@Prop() private searchTerms: object;
	@Prop() private filteredResults: any;
	@Prop() private allData: any;
	@Prop() private filters: any;

	private s: string = '';
	private term: string = '';
	private error = false;

	private selectedFilter: string = '';
	private selectedFilterTerm: string = '';

	private submitSearch() {
		this.error = false;
		let filteredResults = this.allData;

		if (Object.keys(this.searchTerms).length === 1) {
			const getFirstKey = Object.keys(this.searchTerms)[0];
			this.term = getFirstKey;
		}

		if (this.s && this.term) {
			// Our reg ex check breaks if a $ is in the string
			this.s = this.s.replace('$', '');

			const regex = new RegExp(this.s, 'i');
			filteredResults = filteredResults
				.map(result => {
					let getResult;
					if (this.term.indexOf('.') > -1) {
						getResult = result;
						const splitData = this.term.split('.');

						splitData.map(term => {
							getResult = getResult[term];
						});
					} else {
						getResult = result[this.term];
					}

					if (getResult !== undefined) {
						if (getResult.match(regex)) {
							return result;
						}
					}
				})
				.filter(result => {
					if (result !== undefined) {
						return result;
					}
				});
		}
		if (this.selectedFilter && this.selectedFilterTerm) {
			filteredResults = filteredResults.filter(result => {
				let getResult;
				if (this.selectedFilter.indexOf('.') > -1) {
					getResult = result;
					const splitData = this.selectedFilter.split('.');

					splitData.map(term => {
						getResult = getResult[term];
					});
				} else {
					getResult = result[this.selectedFilter];
				}

				if (getResult !== undefined) {
					return getResult.toString() === this.selectedFilterTerm.toString();
				}
			});
		}

		this.$emit('update:filteredResults', filteredResults);
		if (this.paginateKey !== undefined) {
			this.$emit('update:paginateKey', uuid());
		}
	}

	private reset() {
		this.s = '';
		this.term = '';
		this.selectedFilter = '';
		this.selectedFilterTerm = '';
		this.$emit('update:filteredResults', this.allData);
		if (this.paginateKey !== undefined) {
			this.$emit('update:paginateKey', uuid());
		}
	}
}
